import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/auth/me').then(r => setUser(r.data)).catch(() => setUser(null)).finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const r = await api.post('/auth/login', { email, password });
    setUser(r.data);
    return r.data;
  };

  const logout = async () => {
    await api.post('/auth/logout');
    setUser(null);
    window.location.href = '/login';
  };

  const refreshMe = async () => {
    try { const r = await api.get('/auth/me'); setUser(r.data); return r.data; }
    catch { return null; }
  };

  const can = (action) => {
    if (!user) return false;
    const role = user.role;
    switch (action) {
      case 'admin':      return role === 'admin';
      case 'edit':       return ['admin', 'editor'].includes(role);
      case 'contribute': return ['admin', 'editor', 'contributor'].includes(role);
      case 'view':       return true;
      default:           return false;
    }
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, can, refreshMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
